import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { AuthConfig, LoginRequest, LoginResponse, MeResponse } from '@/types/api';

export const ME_KEY = ['me'] as const;
const AUTH_CONFIG_KEY = ['auth-config'] as const;

/**
 * Lê o modo de login ativo no backend (password | entra) para a tela de entrada
 * renderizar o formulário certo sem rebuild. Público — não exige token.
 */
export function useAuthConfig() {
  return useQuery({
    queryKey: AUTH_CONFIG_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get<AuthConfig>('/v1/auth/config');
      return data;
    },
    staleTime: Infinity,
  });
}

/** Login por e-mail + senha (modo padrão). No modo Entra ID o login é por redirect. */
export function useLogin() {
  return useMutation({
    mutationFn: async (body: LoginRequest) => {
      const { data } = await apiClient.post<LoginResponse>('/v1/auth/login', body);
      return data;
    },
  });
}

/**
 * Perfil de quem está logado.
 *
 * @param enabled              busca só quando true (ex.: só com token)
 * @param refetchOnWindowFocus 'always' relê ao voltar para a aba mesmo com o dado recente -
 *                             para telas que precisam notar mudanças feitas em outra janela
 */
export function useMe(enabled = true, refetchOnWindowFocus: boolean | 'always' = false) {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get<MeResponse>('/v1/me');
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus,
  });
}

export function useInvalidateMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ME_KEY });
}
